import { useState } from "react";
import { FAQ } from "../data/faq";
import { useT } from "../i18n";

function Chevron({ open }: { open: boolean }) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="none"
      className={`shrink-0 text-muted transition-transform ${open ? "rotate-180" : ""}`}
    >
      <path d="M6 9l6 6 6-6" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default function Faq() {
  const { t } = useT();
  const [openIdx, setOpenIdx] = useState<number | null>(null);

  if (FAQ.length === 0) return null;

  return (
    <section>
      <h2 className="text-base font-semibold mb-2">{t("faq.title")}</h2>
      <div className="bg-card border border-line-2 rounded-[18px] divide-y divide-white/5">
        {FAQ.map((item, i) => {
          const open = openIdx === i;
          return (
            <div key={item.qKey}>
              <button
                type="button"
                onClick={() => setOpenIdx(open ? null : i)}
                aria-expanded={open}
                className="w-full flex items-center gap-3 p-4 text-left active:bg-white/5 transition-colors"
              >
                <span className="flex-1 text-sm font-medium">{t(item.qKey)}</span>
                <Chevron open={open} />
              </button>
              {open && <p className="px-4 pb-4 -mt-1 text-sm text-muted leading-relaxed">{t(item.aKey)}</p>}
            </div>
          );
        })}
      </div>
    </section>
  );
}
